import styled from "styled-components";

export const StyledOfferingFormAccordionItemPanel = styled.div`
  background-color: #f5f5f5;
  padding: 1.6rem;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  gap: 1.6rem;
  align-items: center;

  &:hover {
    border: 1px solid #1c1726 !important;
    cursor: pointer;
  }

  .offering-form-accordion-item-panel-title {
    color: #1c1726;
    font-weight: 600;
    font-size: 1.6rem;
  }

  .offering-form-accordion-item-panel-summary {
    color: #595959;
    font-size: 1.4rem;
    margin-top: 0.4rem;
  }
`;
